import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/eye.svg
 */
const IconEye: IconComponent = ({
  size = 24,
  color = '#E3E3E3',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M23.805 11.42a15.758 15.758 0 00-5.133-3.927A15.318 15.318 0 0012.448 6h-.42c-2.229.005-4.43.493-6.463 1.433a15.94 15.94 0 00-5.343 4.025.795.795 0 000 1.1c.472.544.98 1.055 1.517 1.53.143.13.326.2.516.201a.81.81 0 00.613-.3.838.838 0 00.1-.916.8.8 0 00-.198-.25c-.29-.257-.582-.531-.874-.83A13.888 13.888 0 017.54 8.397a6.045 6.045 0 00-1.16 3.596c-.003.94.21 1.868.62 2.708a5.95 5.95 0 001.74 2.128 5.711 5.711 0 002.481 1.087 5.638 5.638 0 002.692-.187 5.777 5.777 0 002.32-1.42 6.018 6.018 0 001.447-2.35 6.171 6.171 0 00-.716-5.363 14.117 14.117 0 015.13 3.397c-.228.232-.452.464-.677.665a.826.826 0 00-.266.568.83.83 0 00.45.79.774.774 0 00.879-.127c.452-.433.898-.898 1.319-1.365a.868.868 0 00.005-1.105z"
      fill="currentColor"
    />
  </svg>
);

export default IconEye;
